import { useMemo } from 'react';
import { useSelector } from 'react-redux';

/**
 * Returns the editions owned by the current user for a given artwork.
 * An edition is considered "owned" when:
 *  - it has a certificate (id_certificate !== null)
 *  - the owner_certificate.id matches the current user's id
 *
 * @param {Object|undefined} artwork – artwork object that may contain an editions array
 * @returns {Array} array of owned editions (empty when artwork has no editions or user owns none)
 */
const useOwnedEditions = (artwork) => {
  const currentUserId = useSelector(
    (state) => state.auth?.user?.id ?? state.auth?.account?.user?.id,
  );

  const ownedEditions = useMemo(() => {
    if (!artwork?.editions || !currentUserId) {
      return [];
    }

    return artwork.editions.filter((edition) => {
      const hasCertificate = edition?.id_certificate !== null;
      const isOwner = edition?.owner_certificate?.id === currentUserId;
      return hasCertificate && isOwner;
    });
  }, [artwork?.editions, currentUserId]);

  return ownedEditions;
};

export default useOwnedEditions;
